export enum PartnerTableTypes {
  REGION = "Region",
  RENEWAL_PERIOD = "Subscription Status",
  SUBSCRIPTION_TYPE = "Subscription Type",
  MONTHLY_USAGE = "Monthly Usage %",
  PAYMENT_PLAN = "Customer Payment Type",
}

export enum RenewalPeriodValues {
  TERMINATED = "Terminated",
  ACTIVE = "Active",
  EXPIRED = "Expired",
  WITHIN_30_DAYS = "Within 30 days",
  WITHIN_60_DAYS = "Within 60 days",
  WITHIN_90_DAYS = "Within 90 days",
}

export enum MonthlyUsage {
  WITHIN_LIMIT = "Within Limit",
  OVER_LIMIT = "Over Limit",
}

export enum RadioDeploymentType {
  SAAS = "saas",
  SELF_HOSTED = "self_hosted",
  UNSPECIFIED = "",
}
